module.exports = window["TopWrite"];